//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet-async";
import { Col, Container, Row, Card, Form, Button, Modal } from "react-bootstrap";
import { ManageClientsActions } from "./manageClientsActions";
import { useLocation } from 'react-router-dom';
import { Context } from "../../common/context/Context";
import AlertMessage from "../../common/alertMessages/alertMessages";
import ErrorAlertMessage from "../../common/alertMessages/errorAlertMessage";
import CheckboxList from "../../aAdminTabTeam2/common/otherCommonComponents/CheckboxList";

const EditExistingClient = () => {

    let location = useLocation();
    const context = useContext(Context);
    const [editExistingClientsCMSData, setEditExistingClientsCMSData] = useState({ title: "", description: "", tabNavigationTitle: "", pageContent: {} });
    const [clickCheckBox, setClickCheckBox] = useState(false)
    const [uncheckedList, setUncheckedList] = useState([]);
    const [featuresList, setFeaturesList] = useState([])
    const [showPopupModal, setShowPopupModal] = useState(false)
    const [programList, setProgramList] = useState({
        tools: [],
        assessmentsTasks: [],
        isEventsWebinarsPresent: false,
        isDoceboTilePresent: false,
        eventsWebinars: [],
        doceboTiles: []
    });
    const [checkList, setCheckList] = useState([])
    const [alert, setAlert] = useState({
        message: "",
        type: "",
        showAlert: false
    })
    const [errorAlert, setErrorAlert] = useState({
        showAlert: false
    })
    const showErrorModal = () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        refErrorMessageAlert.showAlert = false;
        setErrorAlert(refErrorMessageAlert)
    }

    const fetchProgramList = async () => {

        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        let { programSetUpId } = location?.state || {};
        let refProgramList = JSON.parse(JSON.stringify(programList));

        try {
            const res = await ManageClientsActions.GetProgramSetupList(programSetUpId);
            if (res.status === 200 || res.status === 204) {
                const resData = res.data || [];
                setFeaturesList(resData);
                const toolsList = resData.filter(x => x.itemType === "Tool");
                const assessmentList = resData.filter(x => x.itemType === "Assessment");
                const eventsList = resData.filter(x => x.itemName === "EventsPage");
                const doceboList = resData.filter(x => x.itemName === "DoceboTile");
                const MyCoachPage = resData.filter(x => x.itemName === "MyCoachPage");
                refProgramList.tools = toolsList;
                refProgramList.assessmentsTasks = assessmentList;
                refProgramList.isEventsWebinarsPresent = eventsList.length > 0;
                refProgramList.isDoceboTilePresent = doceboList.length > 0;
                refProgramList.eventsWebinars = eventsList;
                refProgramList.doceboTiles = doceboList;
                refProgramList.MyCoachPage = MyCoachPage;
                setProgramList(refProgramList);
                setErrorAlert(refErrorMessageAlert);
                window.scrollTo(0, 0);
            }
        } catch (err) {
            console.log(err);
        }
    }

    const fetchEditExistingClientsLabels = (key) => {

        if (editExistingClientsCMSData && editExistingClientsCMSData?.pageContent["Edit-Existing-Client"]) {
            const editExistingClientsCMSDataLabel = editExistingClientsCMSData.pageContent["Edit-Existing-Client"];
            return ManageClientsActions.returnLabel(editExistingClientsCMSDataLabel?.Labels, key)
        }
        return '';
    }

    const fetchCommonComponentLabel = (key) => {
        if (editExistingClientsCMSData && editExistingClientsCMSData?.pageContent["CommonComponent"]) {
            const editExistingClientsCMSDataLabel = editExistingClientsCMSData.pageContent["CommonComponent"];
            return ManageClientsActions.returnLabel(editExistingClientsCMSDataLabel?.Labels, key)
        }
        return '';
    };

    const saveProgramList = async (saveList) => {
        let { programSetUpId } = location && location?.state;
        let refAlert = JSON.parse(JSON.stringify(alert));
        let payload = saveList && saveList;

        await ManageClientsActions.SaveProgramSetupList(
            programSetUpId,
            payload,
        ).then(
            (res) => {
                handleProgramListResponse(
                    res,
                    refAlert,
                    fetchEditExistingClientsLabels,
                    "EditExistingClient.SaveSuccessLabel",
                    "EditExistingClient.SaveErrorLabel",
                    "EditExistingClient.SaveNoResponseLabel",
                    fetchProgramList // onSuccess callback
                );
                setAlert(refAlert);
            },
            (err) => {
                console.log(err);
            },
        );
    };

    const handleClose = () => {
        setShowPopupModal(false);
    }

    const deleteProgramList = async () => {
        let refAlert = JSON.parse(JSON.stringify(alert));
        let { programSetUpId } = location && location?.state;
        handleClose();
        await ManageClientsActions.DeleteProgramSetupList(programSetUpId).then(
            (res) => {
                handleProgramListResponse(
                    res,
                    refAlert,
                    fetchEditExistingClientsLabels,
                    "EditExistingClient.RestoreSuccessLabel",
                    "EditExistingClient.RestoreErrorLabel",
                    "EditExistingClient.RestoreNoResponseLabel",
                    fetchProgramList // onSuccess callback
                );
                setAlert(refAlert);
            },
            (err) => {
                console.log(err);
            },
        );
    };

    function handleProgramListResponse(res, refAlert, fetchLabel, successKey, errorKey, noResponseKey, onSuccess) {
        if (res.status === 200) {
            refAlert.showAlert = true;
            refAlert.type = "success";
            refAlert.message = fetchLabel(successKey);
            if (onSuccess) onSuccess();
        } else if (
            res.status === 500 ||
            res.status === 401 ||
            res.status === 400
        ) {
            refAlert.showAlert = true;
            refAlert.type = "danger";
            refAlert.message = fetchLabel(errorKey);
        } else if (res.status === 204) {
            refAlert.showAlert = true;
            refAlert.type = "danger";
            refAlert.message = res
                ? res
                : fetchLabel(noResponseKey);
        }
    }

    const showModal = () => {
        let refAlert = JSON.parse(JSON.stringify(alert));
        refAlert.showAlert = false;
        setAlert(refAlert)
    }

    const fetchEditExistingClientsCMSData = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        const payload = { pagename: 'Clients' }
        await ManageClientsActions.getAdminClientsCMSContent(payload).then((res) => {
            if (res.status === 200 || res.status === 204) {
                const responseData = res.data;
                responseData.Pages.map((el) => {
                    if (el.Key === "Clients") {
                        const { Title, Description, TabNavigationTitle, Components } = el;
                        setEditExistingClientsCMSData({ title: Title, description: Description, tabNavigationTitle: TabNavigationTitle, pageContent: Components });
                    }
                });
            }
            else {
                refErrorMessageAlert.showAlert = true;
                setErrorAlert(refErrorMessageAlert);
                window.scrollTo(0, 0);
            }
        }, (error) => { console.log(error) });
    }

    const unselectCheckBox = (e, item) => {
        setClickCheckBox(true);

        let listFromResp = featuresList && featuresList.length > 0 && featuresList;
        let modifiedArray =
            listFromResp &&
            listFromResp.map((x) =>
                x.itemDetailsId == item.itemDetailsId
                    ? { ...x, isActive: !x.isActive }
                    : x,
            );
        setUncheckedList(modifiedArray);
        setFeaturesList(modifiedArray);
        let checkedArray = modifiedArray?.filter((x) => x.isActive);
        checkedArray = checkedArray && checkedArray.map((x) => x.itemDetailsId);
        setCheckList(checkedArray && checkedArray);
    };

    const ClientProgramDetails = () => {

        return (
            <div>
                <h3 className="mb-4">{fetchEditExistingClientsLabels("EditExistingClient.ClientProgramDetails")} </h3>
                <Card mt-3>
                    <Card.Title className="mb-0 m-4">{fetchEditExistingClientsLabels("EditExistingClient.Features")}</Card.Title>
                    {programList.tools && programList.tools.length > 0 &&
                        <div>
                            <Card.Header>
                                <Card.Title className="mb-0 m-4">{fetchEditExistingClientsLabels("EditExistingClient.Tools")}</Card.Title>
                            </Card.Header>

                            <Card.Body className="text-left" style={{ display: "flex", flexWrap: "wrap", padding: "0 50px" }}>
                                {errorAlert?.showAlert &&
                                    <ErrorAlertMessage alertMessage="AllPages.ErrorAlertMessage" showAlert={showErrorModal} />
                                }
                                <CheckboxList
                                    items={programList.tools}
                                    checkList={checkList}
                                    clickCheckBox={clickCheckBox}
                                    context={context}
                                    permissionKey="Clients.editclientprogramsetup"
                                    onCheck={unselectCheckBox}
                                />
                            </Card.Body>
                        </div>
                    }
                    {programList.assessmentsTasks && programList.assessmentsTasks.length > 0 &&
                        <div>
                            <Card.Header>
                                <Card.Title className="mb-0 m-4">{fetchEditExistingClientsLabels("EditExistingClient.AssessmentsTasks")}</Card.Title>
                            </Card.Header>

                            <Card.Body className="text-left" style={{ display: "flex", flexWrap: "wrap", padding: "0 50px" }}>
                                <CheckboxList
                                    items={programList.assessmentsTasks}
                                    checkList={checkList}
                                    clickCheckBox={clickCheckBox}
                                    context={context}
                                    permissionKey="Clients.editclientprogramsetup"
                                    onCheck={unselectCheckBox}
                                />
                            </Card.Body>
                        </div>
                    }
                    {(programList?.isEventsWebinarsPresent || programList?.isDoceboTilePresent) &&
                        <div>
                            <Card.Header>
                                <Card.Title className="mb-0 m-4"> {fetchEditExistingClientsLabels("EditExistingClient.EventsWebinars")}</Card.Title>
                            </Card.Header>
                            <Card.Body className="text-left" style={{ padding: "0 50px" }}>
                                <div>
                                    {programList && programList?.isEventsWebinarsPresent &&
                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                style={{ marginRight: "15px" }}
                                                label={fetchEditExistingClientsLabels("EditExistingClient.AllEventsWebinars")}
                                                type="checkbox"
                                                aria-label="Checkbox"
                                                disabled={!context.permissionsList?.includes("Clients.editclientprogramsetup")}
                                                checked={clickCheckBox
                                                    ? !!checkList?.includes(programList?.eventsWebinars?.[0]?.itemDetailsId)
                                                    : !!programList?.eventsWebinars?.[0]?.isActive
                                                }
                                                onClick={(e) => unselectCheckBox(e, programList?.eventsWebinars[0])} />
                                        </Form.Group>
                                    }
                                    {programList && programList?.isDoceboTilePresent &&
                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                style={{ marginRight: "15px" }}
                                                label={fetchEditExistingClientsLabels("EditExistingClient.ClientEventsWebinars")}
                                                type="checkbox"
                                                aria-label="Checkbox"
                                                disabled={!context.permissionsList?.includes("Clients.editclientprogramsetup")}
                                                checked={clickCheckBox
                                                    ? !!checkList?.includes(programList?.doceboTiles?.[0]?.itemDetailsId)
                                                    : !!programList?.doceboTiles?.[0]?.isActive
                                                }
                                                onClick={(e) => unselectCheckBox(e, programList?.doceboTiles[0])} />
                                        </Form.Group>
                                    }
                                </div>
                            </Card.Body>
                        </div>
                    }
                    {
                        programList && programList?.MyCoachPage && programList?.MyCoachPage.length > 0 &&
                        <div>
                            <Card.Header>
                                <Card.Title className="mb-0 m-4">{fetchEditExistingClientsLabels("EditExistingClient.CoachMeeting")}</Card.Title>
                            </Card.Header>

                            <Card.Body className="text-left" style={{ display: "flex", flexWrap: "wrap", padding: "0 50px" }}>
                                {programList && programList?.MyCoachPage.length > 0 &&
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            style={{ marginRight: "15px" }}
                                            label={fetchEditExistingClientsLabels("EditExistingClient.EnableMyCoachpage")}
                                            type="checkbox"
                                            aria-label="Checkbox"
                                            disabled={!context.permissionsList?.includes("Clients.editclientprogramsetup")}
                                            checked={clickCheckBox
                                                ? !!checkList?.includes(programList?.MyCoachPage?.[0]?.itemDetailsId)
                                                : !!programList?.MyCoachPage?.[0]?.isActive
                                            }
                                            onClick={(e) => unselectCheckBox(e, programList?.MyCoachPage[0])} />
                                    </Form.Group>
                                }
                            </Card.Body>
                        </div>
                    }
                </Card>
                {context.permissionsList && context.permissionsList.includes("Clients.editclientprogramsetup") &&
                    <div>
                        {alert?.showAlert &&
                            <AlertMessage alertMessage={alert?.message} alertType={alert?.type} showAlert={showModal} />
                        }
                        <div className="mb-4 text-end">
                            <Button
                                variant="secondary"
                                className="btn-pill me-1 mb-1 m-4"
                                onClick={() => { window.history.back() }}
                            >
                                {fetchCommonComponentLabel("Common.Back")}
                            </Button>
                            <Button
                                variant="secondary"
                                className="btn-pill me-1 mb-1 m-4"
                                onClick={() => setShowPopupModal(true)}
                            >
                                {fetchEditExistingClientsLabels("EditExistingClient.RestoreDefault")}
                            </Button>
                            {showPopupModal &&
                                <Card>
                                    <React.Fragment>
                                        <Modal show={showPopupModal} onHide={(e) => handleClose()}>
                                            <Modal.Header closeButton></Modal.Header>
                                            <Modal.Body className="text-center m-3">
                                                <p className="mb-0">
                                                    {fetchEditExistingClientsLabels("EditExistingClient.WarningMessage")}
                                                </p>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button
                                                    variant="secondary"
                                                    onClick={(e) => handleClose(e)}
                                                >
                                                    {fetchCommonComponentLabel("Common.Cancel")}
                                                </Button>{" "}
                                                <Button
                                                    variant="primary"
                                                    onClick={(e) => deleteProgramList(e)}
                                                >
                                                    {fetchCommonComponentLabel("Common.OK")}
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                    </React.Fragment>
                                </Card>
                            }
                            <Button
                                variant="primary"
                                className="btn-pill me-1 mb-1 m-4"
                                onClick={() => saveProgramList(uncheckedList)}
                                disabled={!clickCheckBox}
                            >
                                {fetchCommonComponentLabel("Common.Save")}
                            </Button>
                        </div>
                    </div>
                }
            </div>
        )
    };

    useEffect(() => {
        window.scrollTo(0, 0)
        fetchProgramList()
        fetchEditExistingClientsCMSData()
    }, [])

    return (
        <React.Fragment>
            <Helmet title="Cards" />
            <Container fluid className="p-0">
                <Row>
                    <Col>
                        <ClientProgramDetails />
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    )
};

export default EditExistingClient;
